var map = {
	"./avalon.en.json": "0d11",
	"./avalon.ru.json": "b5ae",
	"./avalon.ua.json": "abe5",
	"./certificates.en.json": "4998",
	"./certificates.ru.json": "3199",
	"./certificates.ua.json": "bb78",
	"./contacts.ua.json": "9db0",
	"./courses.en.json": "9f3b",
	"./courses.ru.json": "dc67",
	"./courses.ua.json": "7548",
	"./crm.en.json": "fb9f",
	"./crm.ru.json": "7ab9",
	"./crm.ua.json": "b5a8",
	"./discounts.en.json": "82aa",
	"./discounts.ru.json": "014b",
	"./discounts.ua.json": "cd97",
	"./documentflow.ua.json": "2361",
	"./en.json": "edd4",
	"./file_browser.ua.json": "7438",
	"./gamification.ua.json": "8b90",
	"./homepage.en.json": "105f",
	"./homepage.ru.json": "b579",
	"./homepage.ua.json": "14fd",
	"./hr.ua.json": "9932",
	"./mailer.ua.json": "e79c",
	"./meta.ua.json": "c926",
	"./newsletter.en.json": "4324",
	"./newsletter.ru.json": "a9d3",
	"./newsletter.ua.json": "d2c5",
	"./partners.ua.json": "bdae",
	"./projects.ua.json": "e75f",
	"./referral.en.json": "8d2f",
	"./referral.ru.json": "0e6a",
	"./referral.ua.json": "15d0",
	"./ru.json": "7704",
	"./start.ua.json": "521f",
	"./support.en.json": "eb55",
	"./support.ru.json": "35f7",
	"./support.ua.json": "406f",
	"./tests.en.json": "e590",
	"./tests.ru.json": "a72d",
	"./tests.ua.json": "605d7",
	"./ua.json": "94b0",
	"./wsu.ua.json": "3447"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";